module.exports = __webpack_public_path__ + "static/media/black.990aa6b0.jpg";